import { BinIcon } from "../../../../components/icon/Icon";
import { TYPE_TX } from "../../../../modules/Account/components/TransactionHistory/transactionHistoryConstants";

export const getMobileHistoryTransactionIconByTxType = (type) => {
    switch (type) {
        case TYPE_TX.DEPOSIT:
            return 'IcPlusCircleWhite';
        case TYPE_TX.BONUS_CREDIT:
            return 'IcBonusTransaction';
        case TYPE_TX.ADJUSTMENT:
            return 'IcAttentionCircleWhite';
        case TYPE_TX.WITHDRAW:
            return 'IcCard';
        default:
            return ""
    }
}

function MobileHistoryTransactionIcon(props) {
    const {item} = props;
    return <BinIcon name={getMobileHistoryTransactionIconByTxType(item.type)}/>
}

export default MobileHistoryTransactionIcon;
